import { PayLetterSuccessProps, BaseComponentProps } from './PayLetterSuccess.types';

/**
 * PayLetter Success 컴포넌트의 props를 에디터용으로 변환하는 어댑터
 */
export const adaptPayLetterSuccessProps = (props: any): PayLetterSuccessProps => {
  // 기본 BaseComponentProps 처리
  const baseProps: BaseComponentProps = {
    id: props.id,
    className: props.className || 'payletter-success-container',
    style: props.style || {},
    componentProps: props.componentProps || {},
    isEditor: props.isEditor || false,
    isPreview: props.isPreview || false
  };

  // PayLetter Success 전용 props 처리
  const payLetterSuccessProps: PayLetterSuccessProps = {
    ...baseProps,
    content: props.content || {},
    data: {
      title: props.data?.title || props.componentProps?.title || '결제가 완료되었습니다',
      successMessage: props.data?.successMessage || props.componentProps?.successMessage || 'PayLetter 결제가 성공적으로 처리되었습니다.',
      orderButtonText: props.data?.orderButtonText || props.componentProps?.orderButtonText || '주문 내역 확인',
      continueButtonText: props.data?.continueButtonText || props.componentProps?.continueButtonText || '쇼핑 계속하기',
      redirectToOrderHistory: props.data?.redirectToOrderHistory || props.componentProps?.redirectToOrderHistory || '/orders',
      redirectToHome: props.data?.redirectToHome || props.componentProps?.redirectToHome || '/',
      ...props.data
    }
  };

  return payLetterSuccessProps;
}; 